import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const BrandingPage = lazy(() => import('./pages/BrandingPage'));

export const BrandingRoutes: RouteObject = {
  path: 'branding',
  children: [
    { path: '', element: <BrandingPage />, handle: { crumb: 'Branding & Localization' } },
  ],
};
